<section class="section" id="experiences">
  <div class="container">
    <div class="section-head">
      <p class="eyebrow">Expériences</p>
      <h2>Des missions exigeantes et orientées résultats</h2>
      <p class="section-sub">
        Chaque expérience est pensée comme un levier de performance et de fiabilité
        produit.
      </p>
    </div>

    <div class="timeline">
      @for (exp of experiences; track exp.company + exp.period) {
        <article class="timeline-item" appReveal>
        <div class="timeline-marker"></div>
        <div class="timeline-content">
          <div class="timeline-header">
            <div>
              <h3>{{ exp.role }}</h3>
              <p class="company">{{ exp.company }}</p>
            </div>
            <span class="period">{{ exp.period }}</span>
          </div>
          <p class="description">{{ exp.description }}</p>
          <ul>
            @for (item of exp.achievements; track item) {
              <li>{{ item }}</li>
            }
          </ul>
          <div class="stack">
            @for (tech of exp.stack; track tech) {
              <span>{{ tech }}</span>
            }
          </div>
        </div>
      </article>
      }
    </div>
  </div>
</section>
